define(['app', 'jquery'], function (app, $) {
  return app.Marionette.ItemView.extend({
    template: false,

    // Sets the complete header of a forum as button
    ui: {
      button: '.js-collapse-trigger'
    },

    handleEscapeClick: function (e) {
      if (e.code === 'Enter') {
        this.clickedButton(e)
      }
    },

    clickedButton: function (e) {
      e.preventDefault()

      // Set the collapse state and animate it
      $(this.el).toggleClass('is-collapsed')
      $(this.el).find('.js-collapse-content').toggle()
      $(this.el)
        .find('.js-collapse-content')
        .next('.js-collapse-trigger')
        .toggleClass('is-hidden')

      // Set the id of the forum which is pressed for the ajax script
      const id = this.options.id
      if (id) {
        // Save the collapsed state of forums
        $.ajax({
          url: app.url + 'member/collapsed',
          data: {
            type: 'categories',
            id: id
          }
        })
      }
    },

    events: {
      'click @ui.button': 'clickedButton',
      'keypress @ui.button': 'handleEscapeClick'
    },

    // Hide collapsed forums on render
    onRender: function () {
      $('.is-collapsed').find('.js-collapse-content').hide()
    }
  })
})
